import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MappingComponent} from '../../mapping/mapping.component';
import {TranslateService} from '@ngx-translate/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {UpdateFarmDto} from '../../dto/UpdateFarmDto';
import {Router} from '@angular/router';
import {Farm} from '../../models/farm';
import {BehaviorSubject} from 'rxjs';
import {NavBarComponent} from '../../nav-bar/nav-bar.component';
import {BoundaryManagementService} from 'src/app/services/boundary-management.service';

@Component({
    selector: 'app-rename-farm',
    templateUrl: './rename-farm.component.html',
    styleUrls: ['./rename-farm.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RenameFarmComponent {

  farmForm = new FormGroup({
    name: new FormControl('', Validators.compose([
      Validators.required,
      Validators.maxLength(30),
      Validators.pattern(/^((?!\s{2,}).)*$/)
    ]))
  });

  // public farm_validation_messages;
  newFarmName = this.data.name;
  ErrorMessage = "Farm name required";

  public farmSubjects = new BehaviorSubject<Farm[]>(null);
  farms$ = this.farmSubjects.asObservable();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public boundaryManagementService: BoundaryManagementService,
              public nav: NavBarComponent,
              private router: Router,
              public translate: TranslateService,
              private _snackBar: MatSnackBar,
              public dialogRef: MatDialogRef<MappingComponent>) {

    // this.farm_validation_messages = {
    //   'name': [
    //     {type: 'required', message: translate.instant('ADD-FARM-DIALOG.ERROR-NAME-REQUIRED')},
    //     {type: 'maxlength', message: translate.instant('ADD-FARM-DIALOG.ERROR-NAME-LENGTH')},
    //     {type: 'pattern', message: translate.instant('ADD-FARM-DIALOG.ERROR-PATTERN')}
    //   ]
    // }




    this.dialogRef.backdropClick().subscribe(() => {
      this.dialogRef.close({"option": "cancel"});
    });
  }

  ngOnInit(): void {
  }
  cancel() {
    this.dialogRef.close({"option": "cancel"});
  }


  changeFarmName() {
    this.newFarmName = this.farmForm.value.name;
    const id = this.data.id;
    let updateFarmDto: UpdateFarmDto = {
      farmId: id,
      name: this.newFarmName
    }
    this.boundaryManagementService.updateFarm(updateFarmDto).subscribe(() => {
      this.dialogRef.close({"option": "changeFarmName"});
    })
  }
}
